import { font } from '@lokalise/louis';
import { styled } from '@lokalise/styled';

export const Wrapper = styled.div`
    font-family: ${font('family.heading')};
`;
